import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import {
  IContentAreaProps,
  IState,
  Order
} from "../../../types";
import {useSelector} from "react-redux";
import {useAsyncFetch, useFetch} from "../../../system/useFetch";
import FilterComponentBase from "../../../components/filterComponentBase";
import SkeletonView from "../../../components/skeletonView";
import {
  Alert, FormControl,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
//  TableSortLabel
} from "@mui/material";
import TableContainer from "../../../components/tableContainer";
import TablePaginationActions from "../../../components/tablePaginationActions";
import {cloneObject, stableSort} from "../../../system/utils";
import StyledTableRow from "../../../components/styledTableRow";
import {ICellProps, IColumnExtended, IReportData} from "./types";
import Toolbar from "./toolbar";
import Columns from "./columns";
import columns from "./columns";
import SteelSelector from "./SteelSelector";
import HeatSelector from "./heatSelector";

// const pollInterval = 300000;  // 5 min

interface IFilterStatus {
  open: boolean;
  accepted: boolean;
  value: {
    heats: string[];
    grades: string[];
  }
}


function descendingComparator(a: IReportData, b: IReportData, orderBy: string) {

  if (orderBy === "meltHeat") {
    //return b.[0].meltHeat.localeCompare(a.rm[0].meltHeat);
  }

  if (orderBy === "meltGrade") {
    //return b.rm[0].meltGrade.localeCompare(a.rm[0].meltGrade);
  }

  if (orderBy === "heatNumber") {
    return (b.caster?.heatNumber ?? 0) - (a.caster?.heatNumber ?? 0);
  }

  if (orderBy === "steelGrade") {
    return (b.caster?.code ?? "").localeCompare(a.caster?.code ?? "");
  }

  // if (orderBy === "millGrade") {
  //   return b.millGrade.localeCompare(a.millGrade);
  // }
  //
  // if (orderBy === "millHeat") {
  //   return b.millHeat.localeCompare(a.millHeat);
  // }
  //
  // if (orderBy === "microStructure") {
  //   return b.microStructure.localeCompare(a.microStructure);
  // }

  return 0;
}

function getComparator(
    order: Order,
    orderBy: string
): (a: IReportData, b: IReportData) => number {
  return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
}

const headerStyleB= (alternate?: boolean): React.CSSProperties => ({
  position: "sticky",
  top: 0,
  zIndex: 998,
  textAlign: "center",
  background: alternate ? "#99abb4" : "#b0bec5"
});

const headerStyleA = (alternate?: boolean): React.CSSProperties => ({
  position: "sticky",
  top: 34,
  zIndex: 998,
  textAlign: "center",
  background: alternate ? "#99abb4" : "#b0bec5"
});


let flag = 0;

const headerA: ICellProps[] = Columns.reduce((previousValue, currentValue) => {

  if (flag === 0) {
    if (currentValue.labelA) {
      previousValue.push(currentValue.labelA);
      flag = (currentValue.labelA.span ?? 1);
    } else {
      previousValue.push({ label: "", span: 1 });
    }
  }

  flag = flag > 0 ? flag - 1 : 0;

  return previousValue;
}, [] as ICellProps[]);

const headerB: ICellProps[] = Columns.reduce((previousValue, currentValue) => {

  if (flag === 0) {
    if (currentValue.labelB) {
      previousValue.push(currentValue.labelB);
      flag = (currentValue.labelB.span ?? 1);
    } else {
      previousValue.push({ label: "", span: 1 });
    }
  }

  flag = flag > 0 ? flag - 1 : 0;

  return previousValue;
}, [] as ICellProps[]);

const MsRmReport = ({ parentSize }: IContentAreaProps) => {
  const filter = useSelector((state: IState) => state.filter);
  const [ executeRequest, { loading, error, data: reportData  } ] = useAsyncFetch<IReportData[]>();
  const [order, setOrder] = useState<Order>("desc");
  const [orderBy, setOrderBy] = useState<string>("heatNumber");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [ filterStatus, setFilterStatus ] = useState<IFilterStatus>({ open: false, accepted: true, value: { heats: [], grades: [] } });
  const dataLength = reportData ? reportData.length : 0;
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataLength) : 0;
  const filterCache = useRef<IFilterStatus>(filterStatus);


  const gridStyle = {
    height: "100%",
    display: "grid",
    gridTemplateRows: "auto 1fr auto",
    gridTemplateColumns: "1fr",
    overflow: "hidden"
  };

  const hasData = reportData && reportData.length > 0;

  useEffect(() => {
    if (filterStatus.open || !filterStatus.accepted) {

      return;
    }

    executeRequest({
        module: "qa",
        query: "getMsRmReportByFilter",
        payload:
            {
              ...filter.remote,
              ...filterStatus.value
            }
      }).then();

  }, [filter, filterStatus]);


  const createSortHandler = (property: keyof IReportData | "shift") => () => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (_event: React.MouseEvent<HTMLButtonElement> | null, newPage: number,) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onUpdateFilter = (field: "heats" | "grades", values: string[]) => {
    filterCache.current.value[field] = values;
  }

  const customFilter: Record<string, string> = {};
  if (filterStatus.value.heats.length > 1) {
    customFilter.heats = filterStatus.value.heats.join("; ");
  }

  if(filterStatus.value.grades.length > 1) {
    customFilter.grades = filterStatus.value.grades.join("; ");
  }

  const onOpenFilter = () => {
    filterCache.current = cloneObject(filterStatus);
    setFilterStatus(prevState => ({ ...prevState, open: true, accepted: false }));
  }

  const onCloseFilter = (accepted: boolean) => {
    if (accepted) {
      setFilterStatus({ open: false, accepted: true, value: filterCache.current.value });
    } else {
      setFilterStatus(prevState => ({ ...prevState, open: false }));
    }
  }

  return (
      <div className="display-grid" style={gridStyle}>
        <FilterComponentBase loading={loading} disabled={{ shift: true, crew: true }} toolbar={<Toolbar reportData={reportData} />}
                             customFilter={Object.keys(customFilter).length > 0 ? customFilter : undefined }
                             onOpen={onOpenFilter} onClose={onCloseFilter}>
          <HeatSelector onAccept={v => onUpdateFilter("heats", v)} heats={filterCache.current.value.heats} />
          <SteelSelector onAccept={v => onUpdateFilter("grades", v)} grades={filterCache.current.value.grades} />
        </FilterComponentBase>

        {loading && <SkeletonView parentSize={parentSize}/>}
        {error && <Alert severity="warning">{error.message}</Alert>}
        {!loading && !error && !hasData && <Alert severity="warning">No Data to Display.</Alert>}


        {hasData && !loading && !error &&
            <TableContainer style={{ overflow: "auto", minHeight: 0 }}>
              <Table stickyHeader={true} size={"small"} >
                  <TableHead>
                    <TableRow>
                      {headerB.map((cell: ICellProps, index: number) => {

                        return (
                            <TableCell key={`header-b-${index}`} colSpan={cell.span} style={headerStyleB(cell.alternateBg)}>{cell.label}</TableCell>
                        );
                      })}
                    </TableRow>
                    <TableRow>
                      {headerA.map((cell: ICellProps, index: number) => {

                        return (
                            <TableCell key={`header-a-${index}`} colSpan={cell.span} style={headerStyleA(cell.alternateBg)}>{cell.label}</TableCell>
                        );
                      })}
                    </TableRow>
                    <TableRow>
                      {columns.map((column, index) =>
                          column.id !== ""
                              ? <TableCell
                                  className="table-header"
                                  key={`header-${index}`}
                                  align={column.align}
                                  // sortDirection={orderBy === column.id ? order : false}
                                  style={{ minWidth: column.minWidth, top: 68, zIndex: 999,  }}>
                                <span>{column.label}{column.subLabel ? <sub className="ml-1 mr-1">{column.subLabel}</sub> : ""}</span>
                                {/*<TableSortLabel*/}
                                {/*    active={orderBy === column.id}*/}
                                {/*    direction={orderBy === column.id ? order : "asc"}*/}
                                {/*    onClick={createSortHandler(column.id as keyof IReportData | "shift")}>*/}
                                {/*  <span>{column.label}{column.subLabel ? <sub className="ml-1 mr-1">{column.subLabel}</sub> : ""}</span>*/}

                                {/*  {orderBy === column.id*/}
                                {/*    ? <span className="cell-visuallyHidden">{order === "desc" ? "sorted descending" : "sorted ascending"}</span>*/}
                                {/*    : null*/}
                                {/*  }*/}
                                {/*</TableSortLabel>*/}
                              </TableCell>
                              : <TableCell className="table-header" style={{ width: 20 }}/>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody className="selectable" >
                    { reportData && stableSort(reportData, getComparator(order, orderBy))
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, index) => {
                          const rowKey = `row-heat${index}`;
                          const alternate = index % 2 === 0;
                          let opacity = 0.5;

                          return (
                              <React.Fragment key={rowKey}>
                                {Object.values(row.mill).map((millOrder, rmIndex) => {
                                  const millKey = `${rowKey}-mill${rmIndex}`;

                                  return (
                                      <React.Fragment key={millKey}>
                                        {millOrder.strands.map((strand, strandIndex) => {
                                          const strandKey = `${millKey}-strand${strandIndex + 1}`;
                                          // const strandAlternate = strandIndex % 2 === 0;

                                          let background = strand.machineName === "Strand 1"
                                              ? "rgba(207,216,220, 0.2)"
                                              : "rgba(236,239,241, 0.2)";
                                          if (alternate) {
                                            background = strand.machineName === "Strand 1"
                                                ? "rgba(144,164,174, 0.2)"
                                                : "rgba(176,190,197, 0.2)";
                                          }

                                          return (
                                              <StyledTableRow hover={true}
                                                              role="checkbox"
                                                              tabIndex={-1}
                                                              key={strandKey}
                                                              style={{ background }}>
                                                {Columns.map((column: IColumnExtended, colIndex) => {
                                                  const columnKey = `${strandKey}-col${colIndex}`;

                                                  // if (column.mainRow && strandIndex > 0) {
                                                  //
                                                  //   return <TableCell key={columnKey} align={column.align} />;
                                                  // }

                                                  const value = column.accessor
                                                      ? column.accessor(row.caster, millOrder, strandIndex)
                                                      : (row as any)[column.id];

                                                  // if (column.render) {
                                                  //   return (
                                                  //       <TableCell key={`${column.id}-${index}`} align={column.align}>
                                                  //         {column.render(value)}
                                                  //       </TableCell>
                                                  //   );
                                                  // }

                                                  return (
                                                      <TableCell key={columnKey} align={column.align}>
                                                        {column.format ? column.format(value) : value}
                                                      </TableCell>
                                                  );
                                                })}
                                              </StyledTableRow>
                                          );
                                        })}
                                      </React.Fragment>
                                  );
                                })}
                              </React.Fragment>
                          );
                        })}
                    {emptyRows > 0 &&
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6}/>
                        </TableRow>
                    }
                  </TableBody>
                </Table>
            </TableContainer>
        }

        {hasData && !loading && !error &&
            <Table>
              <TableHead>
                <TableRow>
                  <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50, { label: "All", value: -1 }]}
                      colSpan={Columns.length + 1}
                      count={dataLength}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableHead>
            </Table>
        }

      </div>
  );
};

export default MsRmReport;